import React, { useState, useEffect, ReactElement } from 'react';
import { useLayoutEffect } from '@hooks/useIsomorphicLayoutEffect';
import { VerticalTabs, VerticalTabsProps } from '../VerticalTabs';
import * as Accordion from '../Accordion';

export enum Breakpoints {
  sm = 480,
  md = 720,
  lg = 1088,
  xl = 1260,
  xxl = 1616,
}

export interface AccordionToVerticalTabsProps extends VerticalTabsProps {
  breakpoint?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
}

export const AccordionToVerticalTabs = ({
  items,
  classNames,
  breakpoint = 'md',
}: AccordionToVerticalTabsProps): ReactElement => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResizeWindow);
    return () => {
      window.removeEventListener('resize', handleResizeWindow);
    };
  }, []);

  if (width > Breakpoints[breakpoint]) {
    return <VerticalTabs items={items} classNames={classNames} />;
  }

  return (
    <>
      {items.map(({ tabContent, panelContent }, i) => (
        <Accordion.Container
          key={`accordionVerticalTab-${tabContent}`}
          isOpen={i === 0}
        >
          <Accordion.Title>{tabContent}</Accordion.Title>
          <Accordion.Collapsible>{panelContent}</Accordion.Collapsible>
        </Accordion.Container>
      ))}
    </>
  );
};
